import React, { FC, LegacyRef, ReactNode, forwardRef } from "react";
import classNames from "classnames";
import Icon, { IconType } from "../Icon/Icon";
import styles from "./Chip.module.scss";

interface Props {
  className?: string;
  activeClassName?: string;
  dataQA: string;
  icon?: IconType;
  children?: ReactNode;
  outlined?: boolean;
  rounded?: boolean;
  dropdown?: boolean;
  active?: boolean;
  noShadow?: boolean;
  disabled?: boolean;
  style?: Object;
  onClick?: () => void;
}

const Chip: FC<Props> = forwardRef(function Chip(
  {
    dataQA,
    children,
    className,
    activeClassName,
    active = false,
    disabled = false,
    outlined = false,
    rounded = false,
    dropdown = false,
    noShadow = false,
    onClick,
    icon,
    style,
  },
  ref: LegacyRef<HTMLDivElement>,
) {
  return (
    <div
      ref={ref}
      data-qa={dataQA}
      className={classNames(styles.container, className, {
        [styles.active]: active && !activeClassName,
        ...(activeClassName && {
          [activeClassName]: active && activeClassName,
        }),
        [styles.disabled]: disabled,
        [styles.outlined]: outlined,
        [styles.rounded]: rounded,
        [styles.noShadow]: noShadow,
      })}
      onClick={onClick}
      style={style}
    >
      {icon && (
        <Icon
          type={icon}
          width={13}
          height={13}
          dataQA="icon"
          className={styles.icon}
        />
      )}
      {children && <span data-qa="text">{children}</span>}
      {dropdown && (
        <Icon
          type="ChevronDownIcon"
          width={9}
          dataQA="dropdown-icon"
          className={styles.dropdownIcon}
        />
      )}
    </div>
  );
});

export default Chip;
